import React from 'react';
import PropTypes from 'prop-types';

import { capitalize } from 'utils/capitalize';

import Chip from '@mui/material/Chip';

import './styles.css';

const CustomChip = ({ label, styleKey, minwidth, padded, gray }) => {

  const containerClasses = ['chip-container'];
  if (padded) containerClasses.push('padded');

  const classes = ['chip'];

  const chipStyles = {
    active: 'success',
    expiring: 'warning',
    downgrading: 'warning',
    expired: 'error',
    draft: 'warning',
    published: 'success',
    inactive: 'warning',
    free: 'success',
    secret: 'warning',
    discount: "success",
    exclusive: 'exclusive',
    store: 'store',
    shortfall: 'warning'
  };

  classes.push(chipStyles[styleKey || label]);
  if (minwidth) classes.push('minwidth')
  if (gray) classes.push('gray')

  return (
    <div className={containerClasses.join(' ')}>
        <Chip
            label={`• ${capitalize(label)}`}
            variant="outlined"
            className={classes.join(' ')}
        />
    </div>
  );
};

CustomChip.propTypes = {
  label: PropTypes.string,
  styleKey: PropTypes.string,
  minwidth: PropTypes.bool,
  padded: PropTypes.bool,
  gray: PropTypes.bool
};

export default CustomChip;
